import React from "react";
import PdfViewer from "../../PdfViewer";

const AltaColaboradorProcedimiento = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/alta-nuevo-colaborador-proceso.pdf`;
  /*const pdfUrl = "/pdf/alta-nuevo-colaborador-proceso.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Solicitud de Alta de Colaborador</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default AltaColaboradorProcedimiento;
